import { Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from './components/common/ProtectedRoute'
import AdminLayout from './components/layout/AdminLayout'
import Login from './pages/Login'
import SsoSuccess from './pages/SsoSuccess'
import Landing from './pages/Landing'
import CampaignForm from './pages/CampaignForm'
import Guide from './pages/Guide'
import AdminDashboard from './pages/admin/AdminDashboard'
import LeadManagement from './pages/admin/LeadManagement'
import AdminReport from './pages/admin/AdminReport'
import UserManagement from './pages/admin/UserManagement'
import FormOptionManagement from './pages/admin/FormOptionManagement'
import SiteSettingManagement from './pages/admin/SiteSettingManagement'
import MenuManagement from './pages/admin/MenuManagement'
import FormBuilderManagement from './pages/admin/FormBuilderManagement'
import FormBuilderEditor from './pages/admin/FormBuilderEditor'
import TeamManagement from './pages/admin/TeamManagement'
import DeletionLogManagement from './pages/admin/DeletionLogManagement'
import SsoConfigManagement from './pages/admin/SsoConfigManagement'

function App() {
  return (
    <Routes>
      {/* Public landing page (1 trang) */}
      <Route path="/" element={<Landing />} />
      <Route path="/apply" element={<Navigate to="/" replace />} />
      <Route path="/tuyen-dung/:slug" element={<CampaignForm />} />
      <Route path="/huong-dan" element={<Guide />} />
      <Route path="/login" element={<Login />} />
      <Route path="/login/sso/success" element={<SsoSuccess />} />

      {/* Admin (auth required) */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="leads" element={<LeadManagement />} />
        <Route
          path="report"
          element={
            <ProtectedRoute allowedRoles={['admin', 'hr_manager', 'team_lead']}>
              <AdminReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="deletion-logs"
          element={
            <ProtectedRoute allowedRoles={['admin', 'hr_manager', 'team_lead']}>
              <DeletionLogManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="users"
          element={
            <ProtectedRoute allowedRoles={['admin', 'hr_manager', 'team_lead']}>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="teams"
          element={
            <ProtectedRoute allowedRoles={['admin', 'hr_manager', 'team_lead']}>
              <TeamManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="forms"
          element={
            <ProtectedRoute>
              <FormBuilderManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="forms/:id"
          element={
            <ProtectedRoute>
              <FormBuilderEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="options"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <FormOptionManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="settings"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <SiteSettingManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="menus"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <MenuManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="sso"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <SsoConfigManagement />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
